import apiService from './api-service'

const tasksStatusService = {}

tasksStatusService.list = function (params) {
  return apiService.get(`/tasks_status`, { params }).then(res => res.data)
}

export default tasksStatusService



// WEBPACK FOOTER //
// ./src/services/tasks_status.js